import OpenAIClient from "../ai_models/openai_client"
import XunFeiAIClient from "../ai_models/xunfeiai_client"

export default class extends ApplicationController {
    static targets = ["classification",
                      "questionTemplate",
                      "assistantType",
                      "wordsLimit",
                      "question",
                      "answer"]

    static values = { "classification": Array }

    connect() {
        this.initializeClassification()
        this.initializeQuestionTemplate()
    }

    ask(event) {
        this.askQuestion(event.target)
    }

    optimize() {
        this.askQuestion(event.target, true)
    }

    askQuestion(targetButton, isOptimized = false) {
        try {
            const classificationId = this.getInputValue(this.classificationTarget, "提问词分类框为空, 请联系管理员添加!")
            const question = this.makeQuestion(isOptimized)
            const assistantType = this.assistantTypeTarget.value

            this.showLoading(targetButton, true)

            const url = `/qa_assistants/ask_info.json?classification_id=${classificationId}&assistant_type=${assistantType}`
            this.getRequest(url, (askInfo) => {
                const apikey = askInfo["apikey"]
                const openingRemark = askInfo["opening_remark"]

                if (!apikey) {
                    this.showLoading(targetButton, false)

                    const assistantTypeText = this.getSelectedText(this.assistantTypeTarget)
                    alert(`${assistantTypeText}的apikey为空, 请联系管理员添加!`)
                    return
                }

                this.runAIModel(assistantType, apikey, question,
                    (answer) => {
                        this.showLoading(targetButton, false)

                        if (!openingRemark) {
                            const classificationText = this.classificationOptions.getOptionText(classificationId)
                            alert(`${classificationText}分类下的开头语为空, 请联系管理员添加!`)
                        }

                        this.answerTarget.value = `${openingRemark ?? ""}${answer}`
                    },
                    (error) => {
                        this.showLoading(targetButton, false)
                        alert(error)
                    }
                )
            })
        } catch (error) {
            this.showLoading(targetButton, false)
            alert(error.message)
        }
    }

    makeQuestion(isOptimized) {
        let question = this.getInputValue(this.questionTarget, "提问框内容为空, 请检查!")
        const wordsLimitCount = this.getWordsLimitCount()

        if (isOptimized) {
            question += ",优化下这段文字"
        }

        if (wordsLimitCount) {
            question += `,字数不超过${wordsLimitCount}字`
        }

        return question
    }

    runAIModel(assistantType, apikey, question, successCallback, errorCallback) {
        let aiClient = null

        switch (assistantType) {
            case "chatgpt":
                aiClient = new OpenAIClient(apikey)
                break
            case "xunfei_spark":
                let [appId, apiSecret, apiKey] = apikey.split(",")
                aiClient = new XunFeiAIClient(appId, apiSecret, apiKey)
                break
        }

        aiClient?.chatCompletions(question, 0.7, (content) => {
            const answer = content.trim()
            successCallback(answer)
        }, (error) => errorCallback(error))
    }

    initializeClassification() {
        this.classificationOptions = new SelectOptions(this.classificationValue, 10)
        this.classificationTarget.innerHTML = this.classificationOptions.makeHTML()

        this.classificationTarget.onchange = () => { this.fetchQuestionTemplate() }

        this.fetchQuestionTemplate()
    }

    initializeQuestionTemplate() {
        this.questionTemplateTarget.onchange = () => {
            this.setQuestionTemplate()
        }
    }

    fetchQuestionTemplate() {
        const classificationId = this.getSelectedValue(this.classificationTarget)

        if (!classificationId) {
            return
        }

        const url = `/qa_assistants/question_templates.json?classification_id=${classificationId}`

        this.getRequest(url, (questionTemplates) => {
            if (questionTemplates.length === 0) {
                const classificationText = this.classificationOptions.getOptionText(classificationId)
                alert(`${classificationText}分类下没有提问词, 请联系管理员添加!`)

                this.questionTemplateTarget.innerHTML = ""
                return
            }

            this.questionTemplateOptions = new SelectOptions(questionTemplates, 40)

            this.questionTemplateTarget.innerHTML = this.questionTemplateOptions.makeHTML()
            this.setQuestionTemplate()
        })
    }

    setQuestionTemplate() {
        const value = this.getSelectedValue(this.questionTemplateTarget)
        const text = this.questionTemplateOptions.getOptionText(value)

        if (text) {
            const pos = text.indexOf("{}")

            if (pos !== -1) {
                this.questionTarget.value = text.replace("{}", "")

                this.questionTarget.focus()
                this.questionTarget.selectionEnd = pos
            } else {
                this.questionTarget.value = text
            }
        }
    }

    getInputValue(target, errorMessage) {
        const value = target.value

        if (!value) {
            target.focus()
            throw new Error(errorMessage)
        }

        return value
    }

    getWordsLimitCount() {
        if (!this.wordsLimitTarget.value) {
            return null
        }

        const result = parseInt(this.wordsLimitTarget.value)

        if (isNaN(result)) {
            this.wordsLimitTarget.focus()
            throw new Error("字数设定框的内容不是有效数字,请检查!")
        }

        return result
    }

    showLoading(target, isShow) {
        if (isShow) {
            target.classList.add("is-loading")
        } else {
            target.classList.remove("is-loading")
        }
    }
}

class SelectOptions {
    constructor(collection, maxLength, selectedIndex = 0) {
        this.collection = collection
        this.maxLength  = maxLength
        this.selectedIndex = selectedIndex
    }

    getOptionText(value) {
        const option = this.collection.find((option) => option.value == value)

        if (option) {
            return option.text
        } else {
            return ""
        }
    }

    makeHTML() {
        let result = ""

        for (const index in this.collection) {
            let optionHTML = ""

            const option = this.collection[index]

            const value = option.value
            const text = this.truncateText(option.text, this.maxLength)

            if (parseInt(index) === this.selectedIndex) {
                optionHTML = `<option value="${value}" selected="selected">${text}</option>`
            } else {
                optionHTML = `<option value="${value}">${text}</option>`
            }

            result += optionHTML
        }

        return result
    }

    truncateText(text, truncate_at) {
        if (truncate_at >= text.length) {
            return text
        }

        return text.substring(0, truncate_at) + "..."
    }
}